"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "ardesio": {
    "6eaeddce": [{
      "hkey": "f5322ec2",
      "slug": "carpignolo-ponte-seghe",
      "name": "Carpignolo-Ponte Seghe",
      "primary": true,
      "skipSearch": false
    }],
    "ponte-seghe": [{
      "hkey": "f5322ec2",
      "slug": "carpignolo-ponte-seghe",
      "name": "Carpignolo-Ponte Seghe",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;